var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Страница не найдена")]),_c('h2',[_c('router-link',{attrs:{"to":"/projects"}},[_vm._v("К проектам")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }